import type { PracticeMarket } from "./youtube-kalshi";

export const YOUTUBE_KALSHI_MATH = {
  videoId: "t6XzjGJ52sU",
  title: "How to Make Money on Kalshi Using Math (3-Step Process)",
  slug: "kalshi-math",
  path: "/learning-center/watch/kalshi-math",
  flag: "youtube_kalshi_math_walkthrough_v1",
  exposure: "youtube_walkthrough_experiment_entered",
  version: "kalshi_math_walkthrough_v1",
  tool: "/optimizer?sportsbook=kalshi",
} as const;

export const MATH_MARKETS: (PracticeMarket & { opposite: string; slug: string; settlement: string; category: string })[] = [
  {
    id: "rockies", game: "Pittsburgh Pirates vs Colorado Rockies", outcome: "Colorado Rockies −2.5", opposite: "Pittsburgh Pirates +2.5", kind: "Spread", price: 15, contracts: 1000,
    books: [{ id: "novig", name: "Novig", yes: 456, no: -1200 }, { id: "prophetx", name: "ProphetX", yes: 495, no: -1200 }, { id: "fanatics", name: "Fanatics", yes: 500, no: -1200 }],
    category: "Baseball", slug: "rockies-run-line", settlement: "Yes pays $1 per contract if Colorado wins by at least 3 runs; otherwise Yes pays $0.",
  },
  {
    id: "white-sox-tigers", game: "Chicago White Sox vs Detroit Tigers", outcome: "Over 12.5 runs", opposite: "Under 12.5 runs", kind: "Total", price: 21, contracts: 1000,
    books: [{ id: "novig", name: "Novig", yes: 350, no: -400 }, { id: "prophetx", name: "ProphetX", yes: 345, no: -420 }, { id: "fanatics", name: "Fanatics", yes: 355, no: -410 }],
    category: "Baseball", slug: "white-sox-tigers-total", settlement: "Yes pays $1 per contract if the teams combine for at least 13 runs; otherwise Yes pays $0.",
  },
];

export const MATH_LESSONS = [
  { label: "Convert the price", title: "Cents and American odds. Same price.", chapter: 130, next: "Compare the books", instruction: "Kalshi is selected. Upside converts the price automatically. Read the highlighted Kalshi box, then compare the same bet across the market." },
  { label: "Compare the books", title: "One outcome. Several prices.", chapter: 252, next: "See the fair probability", instruction: "Read the same outcome across Novig, ProphetX and Fanatics, like the example in the video. A better price is a signal. Next, remove the margin before judging the edge." },
  { label: "Find the edge", title: "Remove the margin. Find the estimated edge.", chapter: 355, next: "Practice the Kalshi order", instruction: "Upside de-vigs the two sides and estimates a fair chance. Compare it with Kalshi’s price, then click the glowing Kalshi price box to practice the bet." },
] as const;
